import { useEffect, useState } from 'react';

const VALIDATION_HINT_DELAY_MS = 1500;

/** Routine validation stays quiet; only a slow response uses the fixed caption slot. */
export function ClassroomPositionStatus({
  pending,
  caption,
}: {
  readonly pending: boolean;
  readonly caption: string;
}) {
  const [showValidation, setShowValidation] = useState(false);

  useEffect(() => {
    if (!pending) {
      setShowValidation(false);
      return;
    }
    const timer = window.setTimeout(() => setShowValidation(true), VALIDATION_HINT_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, [pending]);

  const text = pending && showValidation ? '正在确认落子，请稍候…' : caption;
  return (
    <small
      className="classroom-position-status"
      role="status"
      aria-live="polite"
      aria-atomic="true"
      title={text}
    >
      {text}
    </small>
  );
}
